module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "aloe_vera.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:12:14 2018",
		"id": 8856521
	},
	"speakers": [
		{
			"duration": "56.85",
			"confidence": null,
			"name": "F1",
			"time": "0.08"
		},
		{
			"duration": "55.66",
			"confidence": null,
			"name": "F2",
			"time": "57.67"
		},
		{
			"duration": "27.96",
			"confidence": null,
			"name": "F1",
			"time": "114.75"
		},
		{
			"duration": "39.80",
			"confidence": null,
			"name": "F3",
			"time": "144.21"
		}
	],
	"words": [
		{
			"duration": "0.06",
			"confidence": "0.940",
			"name": "You",
			"time": "0.08"
		},
		{
			"duration": "0.36",
			"confidence": "0.950",
			"name": "guys",
			"time": "0.14"
		},
		{
			"duration": "0.42",
			"confidence": "0.490",
			"name": "too",
			"time": "0.59"
		},
		{
			"duration": "0.72",
			"confidence": "0.730",
			"name": ".",
			"time": "1.09"
		},
		{
			"duration": "0.37",
			"confidence": "0.600",
			"name": "Today's",
			"time": "2.04"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "the",
			"time": "2.43"
		},
		{
			"duration": "0.66",
			"confidence": "0.990",
			"name": "14th",
			"time": "3.51"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "4.17"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "July",
			"time": "4.26"
		},
		{
			"duration": "0.39",
			"confidence": "0.970",
			"name": ".",
			"time": "5.68"
		},
		{
			"duration": "0.43",
			"confidence": "0.870",
			"name": "Yes",
			"time": "7.03"
		},
		{
			"duration": "0.79",
			"confidence": "0.800",
			"name": ".",
			"time": "8.03"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "I",
			"time": "9.46"
		},
		{
			"duration": "0.28",
			"confidence": "0.700",
			"name": "also",
			"time": "9.58"
		},
		{
			"duration": "0.43",
			"confidence": "0.900",
			"name": "think",
			"time": "9.89"
		},
		{
			"duration": "0.18",
			"confidence": "0.590",
			"name": "because",
			"time": "10.32"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "it's",
			"time": "10.56"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "like",
			"time": "10.74"
		},
		{
			"duration": "0.27",
			"confidence": "0.370",
			"name": ".",
			"time": "12.47"
		},
		{
			"duration": "0.28",
			"confidence": "0.960",
			"name": "But",
			"time": "12.77"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "13.05"
		},
		{
			"duration": "0.48",
			"confidence": "0.970",
			"name": "Anybody",
			"time": "13.47"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "else",
			"time": "13.95"
		},
		{
			"duration": "0.24",
			"confidence": "0.960",
			"name": "like",
			"time": "14.22"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "born",
			"time": "14.46"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "in",
			"time": "14.76"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "14.85"
		},
		{
			"duration": "0.69",
			"confidence": "0.850",
			"name": "90s",
			"time": "14.94"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "grew",
			"time": "16.02"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "up",
			"time": "16.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "with",
			"time": "16.35"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "like",
			"time": "16.47"
		},
		{
			"duration": "0.63",
			"confidence": "0.770",
			"name": "VHS",
			"time": "16.67"
		},
		{
			"duration": "0.31",
			"confidence": "0.830",
			"name": ".",
			"time": "17.33"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "This",
			"time": "18.00"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "is",
			"time": "18.18"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "just",
			"time": "18.30"
		},
		{
			"duration": "0.21",
			"confidence": "0.870",
			"name": "one",
			"time": "18.54"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": "I",
			"time": "18.75"
		},
		{
			"duration": "0.42",
			"confidence": "0.950",
			"name": "have",
			"time": "18.84"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "the",
			"time": "19.52"
		},
		{
			"duration": "0.38",
			"confidence": "0.760",
			"name": "items",
			"time": "19.66"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "family",
			"time": "20.04"
		},
		{
			"duration": "0.22",
			"confidence": "0.490",
			"name": "I",
			"time": "21.96"
		},
		{
			"duration": "0.19",
			"confidence": "0.280",
			"name": "was",
			"time": "22.29"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "really",
			"time": "22.53"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "scary",
			"time": "22.77"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "as",
			"time": "23.19"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "23.31"
		},
		{
			"duration": "0.44",
			"confidence": "1.000",
			"name": "kid",
			"time": "23.37"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "23.81"
		},
		{
			"duration": "0.29",
			"confidence": "0.700",
			"name": "Anyway",
			"time": "24.31"
		},
		{
			"duration": "0.09",
			"confidence": "0.690",
			"name": ".",
			"time": "24.75"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Literally",
			"time": "24.84"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "25.38"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "grew",
			"time": "25.50"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "up",
			"time": "25.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "on",
			"time": "26.01"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "VHS",
			"time": "26.16"
		},
		{
			"duration": "0.10",
			"confidence": "0.960",
			"name": "and",
			"time": "26.90"
		},
		{
			"duration": "0.15",
			"confidence": "0.970",
			"name": "then",
			"time": "27.00"
		},
		{
			"duration": "0.44",
			"confidence": "1.000",
			"name": "eventually",
			"time": "27.15"
		},
		{
			"duration": "0.63",
			"confidence": "0.410",
			"name": "DVDs",
			"time": "27.59"
		},
		{
			"duration": "0.81",
			"confidence": "0.630",
			"name": ".",
			"time": "28.25"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "A",
			"time": "29.46"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "lot",
			"time": "29.52"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "29.76"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "good",
			"time": "29.82"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "memories",
			"time": "30.06"
		},
		{
			"duration": "0.12",
			"confidence": "0.890",
			"name": "of",
			"time": "30.51"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "VHS",
			"time": "30.63"
		},
		{
			"duration": "0.27",
			"confidence": "0.900",
			"name": "as",
			"time": "31.23"
		},
		{
			"duration": "0.13",
			"confidence": "0.900",
			"name": "well",
			"time": "31.88"
		},
		{
			"duration": "0.16",
			"confidence": "0.890",
			"name": "as",
			"time": "32.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "32.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "good",
			"time": "32.40"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "memories",
			"time": "32.61"
		},
		{
			"duration": "0.09",
			"confidence": "0.500",
			"name": "and",
			"time": "33.11"
		},
		{
			"duration": "0.28",
			"confidence": "0.510",
			"name": "my",
			"time": "33.20"
		},
		{
			"duration": "0.22",
			"confidence": "0.400",
			"name": "father",
			"time": "33.49"
		},
		{
			"duration": "0.54",
			"confidence": "0.520",
			"name": "frowns",
			"time": "33.75"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "when",
			"time": "34.74"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "technology",
			"time": "34.92"
		},
		{
			"duration": "0.22",
			"confidence": "0.510",
			"name": "wasn't",
			"time": "35.58"
		},
		{
			"duration": "0.18",
			"confidence": "0.370",
			"name": "used",
			"time": "35.80"
		},
		{
			"duration": "0.65",
			"confidence": "0.970",
			"name": ".",
			"time": "35.99"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "So",
			"time": "36.72"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "37.23"
		},
		{
			"duration": "0.39",
			"confidence": "0.980",
			"name": "Anyway",
			"time": "37.71"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "this",
			"time": "38.13"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "video",
			"time": "38.37"
		},
		{
			"duration": "0.15",
			"confidence": "0.960",
			"name": "is",
			"time": "38.85"
		},
		{
			"duration": "0.07",
			"confidence": "0.530",
			"name": "going",
			"time": "39.00"
		},
		{
			"duration": "0.15",
			"confidence": "0.530",
			"name": "to",
			"time": "39.06"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "be",
			"time": "39.21"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "about",
			"time": "39.51"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "39.99"
		},
		{
			"duration": "0.44",
			"confidence": "0.530",
			"name": "Alvare",
			"time": "40.89"
		},
		{
			"duration": "0.48",
			"confidence": "0.640",
			"name": "juice",
			"time": "41.46"
		},
		{
			"duration": "0.45",
			"confidence": "0.860",
			"name": ".",
			"time": "41.95"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "So",
			"time": "43.80"
		},
		{
			"duration": "0.15",
			"confidence": "0.530",
			"name": "I",
			"time": "44.04"
		},
		{
			"duration": "0.42",
			"confidence": "0.520",
			"name": "then",
			"time": "44.19"
		},
		{
			"duration": "0.05",
			"confidence": "0.900",
			"name": "I",
			"time": "44.75"
		},
		{
			"duration": "0.27",
			"confidence": "0.900",
			"name": "wanted",
			"time": "44.82"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "45.09"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "wait",
			"time": "45.24"
		},
		{
			"duration": "0.21",
			"confidence": "0.760",
			"name": "till",
			"time": "45.48"
		},
		{
			"duration": "0.09",
			"confidence": "0.920",
			"name": "I",
			"time": "45.69"
		},
		{
			"duration": "0.35",
			"confidence": "1.000",
			"name": "used",
			"time": "45.79"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "46.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "46.29"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "46.44"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "little",
			"time": "46.50"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "while",
			"time": "46.74"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "before",
			"time": "47.70"
		},
		{
			"duration": "0.42",
			"confidence": "0.850",
			"name": "I",
			"time": "48.15"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "48.57"
		},
		{
			"duration": "0.33",
			"confidence": "0.980",
			"name": "Talked",
			"time": "48.84"
		},
		{
			"duration": "0.24",
			"confidence": "0.960",
			"name": "about",
			"time": "49.17"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "what",
			"time": "49.47"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "I",
			"time": "49.68"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "49.95"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "Found",
			"time": "50.61"
		},
		{
			"duration": "0.05",
			"confidence": "0.730",
			"name": ".",
			"time": "51.10"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "So",
			"time": "51.84"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "52.83"
		},
		{
			"duration": "0.18",
			"confidence": "0.890",
			"name": "get",
			"time": "52.92"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "this",
			"time": "53.10"
		},
		{
			"duration": "0.15",
			"confidence": "0.960",
			"name": "at",
			"time": "53.28"
		},
		{
			"duration": "0.50",
			"confidence": "0.630",
			"name": "Wal-Mart",
			"time": "53.44"
		},
		{
			"duration": "0.15",
			"confidence": "0.950",
			"name": "it's",
			"time": "53.94"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "like",
			"time": "54.09"
		},
		{
			"duration": "0.33",
			"confidence": "0.670",
			"name": "nine",
			"time": "54.24"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "dollars",
			"time": "54.57"
		},
		{
			"duration": "1.71",
			"confidence": "0.830",
			"name": ".",
			"time": "55.22"
		},
		{
			"duration": "0.34",
			"confidence": "0.850",
			"name": "Yeah",
			"time": "57.67"
		},
		{
			"duration": "0.35",
			"confidence": "0.690",
			"name": ".",
			"time": "58.09"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "Ninety",
			"time": "58.59"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "nine",
			"time": "58.95"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "point",
			"time": "59.22"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "eight",
			"time": "59.52"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "percent",
			"time": "59.73"
		},
		{
			"duration": "0.29",
			"confidence": "0.570",
			"name": "here",
			"time": "60.20"
		},
		{
			"duration": "0.45",
			"confidence": "0.430",
			"name": "elo",
			"time": "60.49"
		},
		{
			"duration": "0.14",
			"confidence": "0.700",
			"name": ".",
			"time": "60.97"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "No",
			"time": "61.29"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "sugars",
			"time": "61.47"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "starches",
			"time": "61.95"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "are",
			"time": "62.49"
		},
		{
			"duration": "0.71",
			"confidence": "0.800",
			"name": "signatories",
			"time": "62.61"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "made",
			"time": "63.33"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "with",
			"time": "63.57"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "naturally",
			"time": "63.72"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "grown",
			"time": "64.23"
		},
		{
			"duration": "0.58",
			"confidence": "0.710",
			"name": "aloe",
			"time": "64.59"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "65.17"
		},
		{
			"duration": "0.27",
			"confidence": "0.860",
			"name": "Says",
			"time": "67.75"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "a",
			"time": "68.40"
		},
		{
			"duration": "0.42",
			"confidence": "0.770",
			"name": "Crinum",
			"time": "68.46"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "full",
			"time": "68.88"
		},
		{
			"duration": "0.34",
			"confidence": "1.000",
			"name": "strength",
			"time": "69.09"
		},
		{
			"duration": "0.48",
			"confidence": "0.630",
			"name": "virtual",
			"time": "69.43"
		},
		{
			"duration": "0.35",
			"confidence": "0.850",
			"name": "juice",
			"time": "69.94"
		},
		{
			"duration": "0.27",
			"confidence": "0.390",
			"name": "fruit",
			"time": "70.34"
		},
		{
			"duration": "0.15",
			"confidence": "0.800",
			"name": "the",
			"time": "70.64"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "Earth",
			"time": "70.80"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "uses",
			"time": "71.10"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "only",
			"time": "71.43"
		},
		{
			"duration": "0.36",
			"confidence": "0.980",
			"name": "fresh",
			"time": "71.67"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "aloe",
			"time": "72.12"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "vera",
			"time": "72.36"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "gel",
			"time": "72.66"
		},
		{
			"duration": "0.69",
			"confidence": "0.830",
			"name": ".",
			"time": "73.11"
		},
		{
			"duration": "0.33",
			"confidence": "0.840",
			"name": "Brendan",
			"time": "73.95"
		},
		{
			"duration": "0.56",
			"confidence": "0.750",
			"name": "Miracle's",
			"time": "74.28"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "man",
			"time": "74.85"
		},
		{
			"duration": "0.18",
			"confidence": "0.940",
			"name": "to",
			"time": "75.10"
		},
		{
			"duration": "0.18",
			"confidence": "0.740",
			"name": "the",
			"time": "75.37"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "75.55"
		},
		{
			"duration": "0.48",
			"confidence": "0.330",
			"name": "Artist",
			"time": "76.13"
		},
		{
			"duration": "0.25",
			"confidence": "0.450",
			"name": "Nick",
			"time": "76.79"
		},
		{
			"duration": "0.45",
			"confidence": "0.990",
			"name": "contains",
			"time": "77.10"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "no",
			"time": "77.61"
		},
		{
			"duration": "0.36",
			"confidence": "0.910",
			"name": "sugar",
			"time": "77.79"
		},
		{
			"duration": "0.46",
			"confidence": "0.700",
			"name": "flavors",
			"time": "78.17"
		},
		{
			"duration": "0.18",
			"confidence": "0.890",
			"name": "so",
			"time": "79.35"
		},
		{
			"duration": "0.81",
			"confidence": "0.890",
			"name": "starches",
			"time": "79.55"
		},
		{
			"duration": "0.17",
			"confidence": "0.810",
			"name": ".",
			"time": "81.67"
		},
		{
			"duration": "0.28",
			"confidence": "0.850",
			"name": "Yet",
			"time": "83.35"
		},
		{
			"duration": "0.33",
			"confidence": "0.710",
			"name": "says",
			"time": "83.66"
		},
		{
			"duration": "0.19",
			"confidence": "0.460",
			"name": "his",
			"time": "84.10"
		},
		{
			"duration": "0.30",
			"confidence": "0.990",
			"name": "father",
			"time": "84.30"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "has",
			"time": "84.60"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "84.81"
		},
		{
			"duration": "0.35",
			"confidence": "1.000",
			"name": "temper",
			"time": "84.87"
		},
		{
			"duration": "0.39",
			"confidence": "0.750",
			"name": "resistant",
			"time": "85.25"
		},
		{
			"duration": "0.35",
			"confidence": "0.960",
			"name": "seal",
			"time": "85.64"
		},
		{
			"duration": "0.12",
			"confidence": "0.490",
			"name": "it",
			"time": "85.99"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "must",
			"time": "86.11"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "86.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "broken",
			"time": "86.46"
		},
		{
			"duration": "0.16",
			"confidence": "0.840",
			"name": "to",
			"time": "86.92"
		},
		{
			"duration": "0.52",
			"confidence": "0.530",
			"name": "dispense",
			"time": "87.09"
		},
		{
			"duration": "0.48",
			"confidence": "0.950",
			"name": "product",
			"time": "87.66"
		},
		{
			"duration": "0.45",
			"confidence": "0.980",
			"name": ".",
			"time": "88.14"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "You",
			"time": "88.59"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "may",
			"time": "88.68"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "notice",
			"time": "88.86"
		},
		{
			"duration": "0.09",
			"confidence": "0.890",
			"name": "a",
			"time": "89.19"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "difference",
			"time": "89.28"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "in",
			"time": "89.79"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "taste",
			"time": "89.94"
		},
		{
			"duration": "0.37",
			"confidence": "1.000",
			"name": "between",
			"time": "90.36"
		},
		{
			"duration": "0.08",
			"confidence": "0.720",
			"name": "the",
			"time": "90.73"
		},
		{
			"duration": "0.23",
			"confidence": "0.820",
			"name": "fruit",
			"time": "90.81"
		},
		{
			"duration": "0.06",
			"confidence": "0.730",
			"name": "of",
			"time": "91.04"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "the",
			"time": "91.11"
		},
		{
			"duration": "0.36",
			"confidence": "0.900",
			"name": "Earth's",
			"time": "91.23"
		},
		{
			"duration": "0.42",
			"confidence": "0.990",
			"name": "cranium",
			"time": "92.01"
		},
		{
			"duration": "0.44",
			"confidence": "0.720",
			"name": "Vergès",
			"time": "92.66"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "93.18"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "other",
			"time": "93.33"
		},
		{
			"duration": "0.30",
			"confidence": "0.430",
			"name": "bands",
			"time": "93.60"
		},
		{
			"duration": "0.26",
			"confidence": "0.330",
			"name": "foes",
			"time": "93.91"
		},
		{
			"duration": "0.21",
			"confidence": "0.570",
			"name": "drinks",
			"time": "94.17"
		},
		{
			"duration": "0.42",
			"confidence": "0.970",
			"name": "Elvir",
			"time": "94.41"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "juice",
			"time": "94.83"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "has",
			"time": "95.10"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "a",
			"time": "95.28"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "distinctive",
			"time": "95.34"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "taste",
			"time": "96.09"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "which",
			"time": "96.87"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "may",
			"time": "97.05"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "not",
			"time": "97.20"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "97.35"
		},
		{
			"duration": "0.48",
			"confidence": "0.960",
			"name": "president",
			"time": "97.47"
		},
		{
			"duration": "0.42",
			"confidence": "0.970",
			"name": "products",
			"time": "97.95"
		},
		{
			"duration": "0.32",
			"confidence": "0.730",
			"name": "unless",
			"time": "98.40"
		},
		{
			"duration": "0.16",
			"confidence": "0.780",
			"name": "you",
			"time": "98.75"
		},
		{
			"duration": "0.50",
			"confidence": "0.660",
			"name": "curity",
			"time": "98.95"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "99.45"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "Regardless",
			"time": "99.78"
		},
		{
			"duration": "0.14",
			"confidence": "1.000",
			"name": "of",
			"time": "100.41"
		},
		{
			"duration": "0.34",
			"confidence": "0.700",
			"name": "legal",
			"time": "100.56"
		},
		{
			"duration": "0.47",
			"confidence": "0.520",
			"name": "claims",
			"time": "100.94"
		},
		{
			"duration": "1.32",
			"confidence": "0.950",
			"name": ".",
			"time": "101.52"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "So",
			"time": "103.56"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "103.77"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "was",
			"time": "103.86"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "pretty",
			"time": "104.04"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "nervous",
			"time": "104.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "to",
			"time": "104.82"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "try",
			"time": "105.72"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "this",
			"time": "106.05"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "106.29"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "couple",
			"time": "106.35"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "months",
			"time": "106.65"
		},
		{
			"duration": "0.44",
			"confidence": "1.000",
			"name": "ago",
			"time": "106.95"
		},
		{
			"duration": "0.62",
			"confidence": "0.520",
			"name": "cause",
			"time": "108.29"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "108.91"
		},
		{
			"duration": "0.27",
			"confidence": "0.980",
			"name": "Like",
			"time": "109.52"
		},
		{
			"duration": "0.34",
			"confidence": "0.920",
			"name": "with",
			"time": "109.80"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "tasting",
			"time": "110.22"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "any",
			"time": "110.70"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "new",
			"time": "110.91"
		},
		{
			"duration": "0.27",
			"confidence": "0.990",
			"name": "thing",
			"time": "111.09"
		},
		{
			"duration": "0.12",
			"confidence": "0.830",
			"name": "I",
			"time": "111.36"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "get",
			"time": "111.48"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "like",
			"time": "111.69"
		},
		{
			"duration": "0.48",
			"confidence": "0.610",
			"name": "dieties",
			"time": "112.35"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "so",
			"time": "112.86"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "113.33"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "I",
			"time": "114.75"
		},
		{
			"duration": "0.27",
			"confidence": "0.940",
			"name": "thought",
			"time": "114.84"
		},
		{
			"duration": "0.36",
			"confidence": "0.980",
			"name": "OK",
			"time": "115.48"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "116.46"
		},
		{
			"duration": "0.15",
			"confidence": "0.910",
			"name": "if",
			"time": "116.61"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "this",
			"time": "116.76"
		},
		{
			"duration": "0.24",
			"confidence": "0.950",
			"name": "makes",
			"time": "116.94"
		},
		{
			"duration": "0.12",
			"confidence": "0.940",
			"name": "me",
			"time": "117.18"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "sick",
			"time": "117.30"
		},
		{
			"duration": "0.03",
			"confidence": "0.660",
			"name": ".",
			"time": "117.60"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "But",
			"time": "117.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "119.37"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "know",
			"time": "119.49"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "I've",
			"time": "119.79"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "used",
			"time": "120.30"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "this",
			"time": "120.54"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "for",
			"time": "120.81"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "121.02"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "few",
			"time": "121.08"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "years",
			"time": "121.32"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "now",
			"time": "121.62"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "121.92"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "hair",
			"time": "122.10"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "sometimes",
			"time": "122.94"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "mixed",
			"time": "123.42"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "with",
			"time": "123.72"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "vinegar",
			"time": "123.84"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "so",
			"time": "124.71"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "125.4"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I've",
			"time": "126.30"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "used",
			"time": "126.45"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "126.78"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "like",
			"time": "126.93"
		},
		{
			"duration": "0.12",
			"confidence": "0.890",
			"name": "on",
			"time": "127.17"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "127.29"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "skin",
			"time": "127.44"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "128.25"
		},
		{
			"duration": "0.36",
			"confidence": "0.970",
			"name": "that",
			"time": "128.37"
		},
		{
			"duration": "0.56",
			"confidence": "1.000",
			"name": "so",
			"time": "128.73"
		},
		{
			"duration": "0.25",
			"confidence": "0.930",
			"name": "yeah",
			"time": "130.19"
		},
		{
			"duration": "0.05",
			"confidence": "0.770",
			"name": ".",
			"time": "130.51"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "So",
			"time": "130.56"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "the",
			"time": "130.77"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "first",
			"time": "130.92"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "time",
			"time": "131.31"
		},
		{
			"duration": "0.15",
			"confidence": "0.880",
			"name": "I",
			"time": "131.70"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "tried",
			"time": "131.85"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "it",
			"time": "132.33"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "132.59"
		},
		{
			"duration": "0.17",
			"confidence": "0.900",
			"name": "I'll",
			"time": "134.18"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "134.46"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "say",
			"time": "134.64"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "how",
			"time": "134.82"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "many",
			"time": "134.94"
		},
		{
			"duration": "0.36",
			"confidence": "0.980",
			"name": "litres",
			"time": "135.15"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "this",
			"time": "135.51"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "is",
			"time": "135.75"
		},
		{
			"duration": "1.47",
			"confidence": "0.920",
			"name": ".",
			"time": "136.02"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "Three",
			"time": "137.49"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "point",
			"time": "137.82"
		},
		{
			"duration": "0.32",
			"confidence": "0.520",
			"name": "seventy",
			"time": "138.15"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "eight",
			"time": "138.47"
		},
		{
			"duration": "0.63",
			"confidence": "0.880",
			"name": "litres",
			"time": "138.69"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "139.32"
		},
		{
			"duration": "0.63",
			"confidence": "0.500",
			"name": "Yes",
			"time": "140.28"
		},
		{
			"duration": "0.14",
			"confidence": "0.560",
			"name": ".",
			"time": "140.94"
		},
		{
			"duration": "0.13",
			"confidence": "1.000",
			"name": "The",
			"time": "141.11"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "first",
			"time": "141.24"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "time",
			"time": "141.60"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "141.90"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "tried",
			"time": "141.99"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "it",
			"time": "142.50"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "142.71"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "I",
			"time": "144.21"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "had",
			"time": "145.14"
		},
		{
			"duration": "0.20",
			"confidence": "0.950",
			"name": "it",
			"time": "145.42"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "145.77"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "little",
			"time": "145.86"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "bit",
			"time": "146.07"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "by",
			"time": "146.25"
		},
		{
			"duration": "0.51",
			"confidence": "0.930",
			"name": "itself",
			"time": "146.46"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "147.00"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "147.09"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "tasted",
			"time": "147.18"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "really",
			"time": "147.63"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "strong",
			"time": "147.99"
		},
		{
			"duration": "0.28",
			"confidence": "0.930",
			"name": "so",
			"time": "149.83"
		},
		{
			"duration": "0.14",
			"confidence": "0.800",
			"name": "that",
			"time": "150.19"
		},
		{
			"duration": "0.12",
			"confidence": "0.720",
			"name": "I",
			"time": "150.36"
		},
		{
			"duration": "0.36",
			"confidence": "0.830",
			"name": "mixed",
			"time": "150.48"
		},
		{
			"duration": "0.39",
			"confidence": "0.920",
			"name": ".",
			"time": "150.84"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "This",
			"time": "151.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "is",
			"time": "151.50"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "what",
			"time": "151.62"
		},
		{
			"duration": "0.09",
			"confidence": "0.810",
			"name": "I",
			"time": "151.80"
		},
		{
			"duration": "0.34",
			"confidence": "1.000",
			"name": "get",
			"time": "151.89"
		},
		{
			"duration": "0.03",
			"confidence": "0.720",
			"name": ".",
			"time": "152.23"
		},
		{
			"duration": "0.15",
			"confidence": "0.900",
			"name": "It's",
			"time": "152.34"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "like",
			"time": "152.49"
		},
		{
			"duration": "0.59",
			"confidence": "0.970",
			"name": "99",
			"time": "152.67"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "cents",
			"time": "153.27"
		},
		{
			"duration": "0.09",
			"confidence": "0.980",
			"name": "at",
			"time": "153.57"
		},
		{
			"duration": "0.48",
			"confidence": "0.580",
			"name": "Wal-Mart",
			"time": "153.66"
		},
		{
			"duration": "0.48",
			"confidence": "0.810",
			"name": "Birdie's",
			"time": "154.17"
		},
		{
			"duration": "0.32",
			"confidence": "0.970",
			"name": "apple",
			"time": "154.65"
		},
		{
			"duration": "0.24",
			"confidence": "0.540",
			"name": "juice",
			"time": "154.97"
		},
		{
			"duration": "0.45",
			"confidence": "0.540",
			"name": "is",
			"time": "155.21"
		},
		{
			"duration": "0.24",
			"confidence": "0.930",
			"name": "one",
			"time": "156.03"
		},
		{
			"duration": "0.42",
			"confidence": "0.800",
			"name": "later",
			"time": "156.27"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": ".",
			"time": "156.72"
		},
		{
			"duration": "0.14",
			"confidence": "0.960",
			"name": "So",
			"time": "157.70"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "157.86"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I'll",
			"time": "158.01"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "do",
			"time": "158.13"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "is",
			"time": "158.37"
		},
		{
			"duration": "0.09",
			"confidence": "0.620",
			"name": "I'll",
			"time": "158.49"
		},
		{
			"duration": "0.25",
			"confidence": "0.620",
			"name": "miss",
			"time": "158.60"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "158.85"
		},
		{
			"duration": "0.14",
			"confidence": "0.950",
			"name": "bit",
			"time": "158.88"
		},
		{
			"duration": "0.04",
			"confidence": "0.480",
			"name": "of",
			"time": "159.02"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "apple",
			"time": "159.06"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "juice",
			"time": "159.42"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "159.87"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "159.99"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "helps",
			"time": "160.20"
		},
		{
			"duration": "0.22",
			"confidence": "0.620",
			"name": "soothe",
			"time": "160.52"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "the",
			"time": "160.74"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "taste",
			"time": "160.83"
		},
		{
			"duration": "1.15",
			"confidence": "0.880",
			"name": ".",
			"time": "161.43"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "So",
			"time": "162.84"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "yeah",
			"time": "163.08"
		},
		{
			"duration": "0.15",
			"confidence": "0.960",
			"name": "when",
			"time": "163.26"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "163.41"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "first",
			"time": "163.50"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "tried",
			"time": "164.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "164.52"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "164.70"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "thought",
			"time": "164.85"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "wow",
			"time": "165.18"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "165.48"
		},
		{
			"duration": "0.13",
			"confidence": "0.930",
			"name": "is",
			"time": "165.83"
		},
		{
			"duration": "0.24",
			"confidence": "0.930",
			"name": "kind",
			"time": "165.96"
		},
		{
			"duration": "0.06",
			"confidence": "0.930",
			"name": "of",
			"time": "166.20"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "like",
			"time": "166.26"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "hair",
			"time": "167.07"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "gel",
			"time": "167.34"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "167.64"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "little",
			"time": "167.67"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "bit",
			"time": "167.97"
		},
		{
			"duration": "0.17",
			"confidence": "0.970",
			"name": "like",
			"time": "168.59"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "168.78"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "don't",
			"time": "168.84"
		},
		{
			"duration": "0.13",
			"confidence": "1.000",
			"name": "know",
			"time": "168.96"
		},
		{
			"duration": "0.11",
			"confidence": "0.700",
			"name": "what",
			"time": "169.09"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "hair",
			"time": "169.20"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "gel",
			"time": "169.47"
		},
		{
			"duration": "0.39",
			"confidence": "0.930",
			"name": "tastes",
			"time": "169.71"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "170.10"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "but",
			"time": "170.34"
		},
		{
			"duration": "0.20",
			"confidence": "0.510",
			"name": "I",
			"time": "170.83"
		},
		{
			"duration": "0.49",
			"confidence": "0.640",
			"name": "tasted",
			"time": "171.51"
		},
		{
			"duration": "0.22",
			"confidence": "0.790",
			"name": "it",
			"time": "172.02"
		},
		{
			"duration": "0.14",
			"confidence": "0.620",
			"name": ".",
			"time": "172.24"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "I",
			"time": "172.44"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "was",
			"time": "172.86"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "173.07"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "173.31"
		},
		{
			"duration": "0.45",
			"confidence": "0.920",
			"name": "probably",
			"time": "173.52"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "173.97"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "what",
			"time": "174.12"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "hair",
			"time": "174.33"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "gel",
			"time": "174.60"
		},
		{
			"duration": "0.33",
			"confidence": "0.920",
			"name": "tastes",
			"time": "174.90"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "like",
			"time": "175.23"
		},
		{
			"duration": "0.44",
			"confidence": "0.860",
			"name": ".",
			"time": "175.48"
		},
		{
			"duration": "0.11",
			"confidence": "0.560",
			"name": "It",
			"time": "175.96"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "176.07"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "Sounds",
			"time": "176.31"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "weird",
			"time": "176.70"
		},
		{
			"duration": "0.38",
			"confidence": "0.700",
			"name": ".",
			"time": "177.06"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "So",
			"time": "177.60"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "178.89"
		},
		{
			"duration": "0.22",
			"confidence": "0.930",
			"name": "go",
			"time": "178.98"
		},
		{
			"duration": "0.48",
			"confidence": "0.570",
			"name": "servo",
			"time": "179.20"
		},
		{
			"duration": "0.27",
			"confidence": "0.620",
			"name": "to",
			"time": "179.68"
		},
		{
			"duration": "0.24",
			"confidence": "0.820",
			"name": "these",
			"time": "179.97"
		},
		{
			"duration": "0.26",
			"confidence": "0.930",
			"name": "just",
			"time": "180.21"
		},
		{
			"duration": "0.13",
			"confidence": "0.330",
			"name": "that",
			"time": "180.47"
		},
		{
			"duration": "0.31",
			"confidence": "0.880",
			"name": "day",
			"time": "180.60"
		},
		{
			"duration": "0.02",
			"confidence": "0.590",
			"name": ".",
			"time": "180.91"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "This",
			"time": "180.93"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "is",
			"time": "181.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "181.23"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "181.38"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "looks",
			"time": "181.47"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "like",
			"time": "181.71"
		},
		{
			"duration": "0.02",
			"confidence": "0.800",
			"name": ".",
			"time": "181.90"
		},
		{
			"duration": "0.43",
			"confidence": "0.810",
			"name": "Floyd",
			"time": "181.92"
		},
		{
			"duration": "0.18",
			"confidence": "0.760",
			"name": "just",
			"time": "182.35"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "picked",
			"time": "182.55"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "up",
			"time": "182.82"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "another",
			"time": "183.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "one",
			"time": "183.33"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "today",
			"time": "183.48"
		},
		{
			"duration": "0.02",
			"confidence": "0.560",
			"name": ".",
			"time": "183.99"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/aloe_vera.json
// module id = 23
// module chunks = 0